<template>
  <el-container style="height: calc(100% - 65px);overflow-y: hidden">
    <el-aside width="200px">
      <el-col :span="24">
        <el-menu :default-active="activeIndex" router class="el-menu-vertical-demo">
          <el-menu-item index="/admin/contribute_manage"><span slot="title">比赛进度管理</span></el-menu-item>
          <el-menu-item index="/admin/time_manage"><span slot="title">阶段时间设置</span></el-menu-item>
          <el-menu-item index="/admin/enter_for_check"><span slot="title">团队报名信息</span></el-menu-item>
          <el-menu-item index="/admin/player_manage"><span slot="title">普通用户列表(未开放编辑)</span></el-menu-item>
          <el-menu-item index="/admin/user"><span slot="title">审稿老师/管理员管理</span></el-menu-item>
          <el-menu-item index="/admin/thesis_allot"><span slot="title">审稿老师分配</span></el-menu-item>
          <el-menu-item index="/admin/thesis_last"><span slot="title">当前阶段终审</span></el-menu-item>
          <el-menu-item index="/admin/notice_manage"><span slot="title">通知公告管理</span></el-menu-item>
          <el-menu-item index="/instruction"><span slot="title">操作说明</span></el-menu-item>
        </el-menu>
      </el-col>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>

  export default {
    name: "admin",
    data() {
      return {
        activeIndex:'/',
      }
    },

    methods: {
      setCurrentRoute() {
        this.activeIndex= this.$route.path; // 通过他就可以监听到当前路由状态并激活当前菜单
      }
    },

    created() {
      this.setCurrentRoute();
    },

    watch: {
      $route() {
        this.setCurrentRoute();
      }
    },
  }

</script>
<style scoped>
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 800px;
    height: 100%;
  }

  .el-main {
    /* background-color: #E9EEF3;*/
    color: #333;
    text-align: center;
    line-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/page/Admin/Admin.vue